// extracted by mini-css-extract-plugin
export default {"tag":"CustomTags_tag__IuWUH"};